module.exports = __webpack_public_path__ + "static/media/mango.a0844a25.svg";